import { motion } from "framer-motion";
import { MicroLabel } from "@/components/decor/CropMarks";

const POINTS = [
  {
    n: "01",
    t: "All-in-One Execution",
    d: "Print, gifting, signage, packaging and promotional execution under one roof — fewer vendors, fewer errors.",
  },
  {
    n: "02",
    t: "Offline Branding Strength",
    d: "Tangible brand expression — built for shelves, walls, gift desks, events and reception areas.",
  },
  {
    n: "03",
    t: "Corporate Gifting Expertise",
    d: "Curated, occasion-aware gifting designed around recipient experience, not just merchandise.",
  },
  {
    n: "04",
    t: "Production Knowledge",
    d: "Materials, finishes, tolerances and timelines — handled by people who understand the floor.",
  },
  {
    n: "05",
    t: "Trust-Based Service",
    d: "Briefs respected. Deliveries kept. Communication clear at every stage of every project.",
  },
  {
    n: "06",
    t: "Premium Yet Practical",
    d: "Quality you can feel, priced for sustained partnership — not one-time spectacle.",
  },
  {
    n: "07",
    t: "Long-Term Client Trust",
    d: "Most of our work comes from repeat clients who treat Krister as their in-house production partner.",
  },
];

const WhyKrister = () => {
  return (
    <section
      data-testid="why-krister"
      className="relative"
      style={{ background: "#F5F1E8", paddingTop: 120, paddingBottom: 120 }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3">
              <span style={{ width: 22, height: 1, background: "#0A0A0A", opacity: 0.7 }} />
              <span className="ko-overline" style={{ color: "#0A0A0A" }}>
                09 / Why Krister
              </span>
            </div>
            <h2
              className="mt-6"
              style={{
                fontFamily: "Montserrat",
                fontWeight: 800,
                color: "#0A0A0A",
                fontSize: "clamp(34px, 5vw, 64px)",
                lineHeight: 0.98,
                letterSpacing: "-0.025em",
                textTransform: "uppercase",
                maxWidth: 900,
              }}
            >
              The reasons brands
              <br />
              <span style={{ color: "#B89B5E" }}>keep coming back.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px" style={{ background: "rgba(10,10,10,0.18)" }}>
          {POINTS.map((p, i) => (
            <motion.div
              key={p.n}
              data-testid={`why-card-${p.n}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className="relative group p-8"
              style={{
                background: "#F5F1E8",
                color: "#0A0A0A",
                minHeight: 280,
                transition: "background 0.4s ease",
              }}
              whileHover={{ backgroundColor: "#0A0A0A", color: "#F5F1E8" }}
            >
              <div className="flex items-start justify-between">
                <span
                  style={{
                    fontFamily: "Montserrat",
                    fontWeight: 900,
                    fontSize: 64,
                    lineHeight: 1,
                    color: "inherit",
                    letterSpacing: "-0.04em",
                  }}
                >
                  {p.n}
                </span>
                <span
                  aria-hidden
                  className="ko-blink"
                  style={{ width: 8, height: 8, background: "#B89B5E" }}
                />
              </div>
              <h3
                className="mt-10"
                style={{
                  fontFamily: "Montserrat",
                  fontWeight: 700,
                  fontSize: "clamp(18px, 1.6vw, 22px)",
                  letterSpacing: "-0.01em",
                  lineHeight: 1.15,
                }}
              >
                {p.t}
              </h3>
              <p
                className="mt-4"
                style={{
                  fontSize: 13.5,
                  lineHeight: 1.7,
                  opacity: 0.9,
                }}
              >
                {p.d}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyKrister;
